export enum BeachVolleyballStatId {
  ServiceAces = 48,
  ServiceErrors = 49,
}
